import * as React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

type Props = {
  value: string;
  highlight?: boolean;
};

const BenchmarkFont = createGlobalStyle`
@font-face {
  font-family: 'PF Benchmark Pro';
  src: url('https://fonts.mybet.com/pfbenchmarkpro-bolditalic.woff2') format('woff2'),
       url('https://fonts.mybet.com/pfbenchmarkpro-bolditalic.woff') format('woff'),
       url('https://fonts.mybet.com/pfbenchmarkpro-bolditalic.ttf') format('truetype');
  font-weight: bold;
}
`;

const MainTitle = styled.h1<{ highlight: boolean }>(({ theme, highlight }) => ({
  fontFamily: '"PF Benchmark Pro", Roboto, sans-serif',
  color: theme[highlight ? 'blue07' : 'white'],
  fontSize: '26px',
  lineHeight: '28px',
  letterSpacing: '.17px',
  textAlign: 'center',
  textTransform: 'uppercase',
  textShadow: '0 2px 4px rgba(0,0,0,0.15)',
  margin: 0,

  '@media screen and (min-width: 768px)': {
    fontSize: '56px',
    lineHeight: '60px',
    letterSpacing: '.37px',
  },
}));

const Title: React.FC<Props> = ({ value, highlight = false }) => {
  return (
    <>
      <BenchmarkFont />
      <MainTitle highlight={highlight}>{value}</MainTitle>
    </>
  );
};

export default Title;
